//西班牙语
export default {
  Login: {
    Title: "Inicia sesión en tu cuenta",
    describe: "Por favor, inicia sesión o crea una cuenta para comenzar.",
    Google: "Continuar con Google",
    Apple: "Continuar con Apple",
    or: "O",
    Emailplaceholder: "Dirección de correo electrónico",
    Passwordplaceholder: "Contraseña",
    Login: "Iniciar sesión",
    forgot: "¿Olvidaste tu contraseña?",
    notAccount: "¿No tienes una cuenta de Fineshare?",
    Signup: "Registrarse",
    InvalidEmail: "Formato de correo electrónico inválido.",
    InvalidPassword: "La contraseña debe tener al menos 6 caracteres.",
    loading: "Cargando...",
    login: "Iniciar sesión",
    errorText: "Error al iniciar sesión, por favor revisa tu nombre de usuario y contraseña",
  },
  signup: {
    Title: "Crea tu cuenta",
    describe: "Crea tu cuenta de Fineshare en segundos.",
    Google: "Registrarse con Google",
    Apple: "Registrarse con Apple",
    or: "O",
    Emailplaceholder: "Ingresa la dirección de correo electrónico",
    Passwordplaceholder: "Ingresa una contraseña de 6 dígitos",
    Already: "¿Ya tienes una cuenta?",
    Login: "Iniciar sesión",
    By: "Al crear una cuenta, acepto que he leído y acepto la",
    Privacy: "Política de privacidad",
    Terms: "Términos de uso.",
    and: "y",
    signupText: "Crea tu cuenta",
    InvalidEmail: "Formato de correo electrónico inválido.",
    InvalidPassword: "La contraseña debe tener al menos 6 caracteres.",
    loading: "Cargando...",
    passwordError: "La dirección de correo electrónico ya ha sido registrada",
    again: "Estás haciendo demasiadas solicitudes, por favor intenta más tarde",
    Registration: "Registro fallido, por favor revisa tu correo electrónico y contraseña.",
    hasRegistered: "La dirección de correo electrónico ya ha sido registrada",
  },
  Home: {
    Welcome: "Bienvenido al Centro de Cuentas de Fineshare",
  },
};